import { useState, useEffect } from "react";
import { Box, Typography, Button, Card, CardContent, TextField, Avatar, Chip, CircularProgress, Snackbar, Divider } from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";

const token = () => localStorage.getItem("biyz_token");
const authHead = () => ({ Authorization: `Bearer ${token()}`, "Content-Type": "application/json" });

export default function FriendsPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [toast, setToast] = useState("");

  const load = () => {
    fetch("/api/platform/gamification/friends", { headers: authHead() })
      .then(r => r.json()).then(d => { if (d?.ok) setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  };
  useEffect(load, []);

  const sendRequest = async () => {
    const c = code.trim();
    if (!c) return;
    setBusy(true);
    try {
      const res = await fetch("/api/platform/gamification/friends/request", {
        method: "POST", headers: authHead(), body: JSON.stringify({ code: c }),
      });
      const d = await res.json();
      setToast(d.ok ? "İstek gönderildi ✓" : (d.message || "Gönderilemedi"));
      if (d.ok) setCode("");
    } catch { setToast("Sunucu hatası"); }
    finally { setBusy(false); }
  };

  const accept = async (userId) => {
    setBusy(true);
    try {
      const res = await fetch("/api/platform/gamification/friends/accept", {
        method: "POST", headers: authHead(), body: JSON.stringify({ userId }),
      });
      const d = await res.json();
      setToast(d.ok ? "Arkadaş eklendi ✓" : (d.message || "Eklenemedi"));
      if (d.ok) load();
    } catch { setToast("Sunucu hatası"); }
    finally { setBusy(false); }
  };

  if (loading) return <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}><CircularProgress /></Box>;

  const friends = data?.friends || [];
  const requests = data?.requests || [];

  return (
    <Box sx={{ maxWidth: 640, mx: "auto", px: { xs: 1.5, sm: 3 }, py: 3, width: "100%", boxSizing: "border-box" }}>
      <Typography variant="h5" fontWeight={800} sx={{ color: "#1a2238", mb: 0.5 }}>Arkadaşların 👥</Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Arkadaşlarınla aynı ligde yarış, birbirinizi motive edin. Davet kodunu paylaşarak ekleyin.
      </Typography>

      {/* Kod ile ekle */}
      <Card sx={{ borderRadius: 4, mb: 2.5, border: "1px solid rgba(120,140,200,0.16)" }}>
        <CardContent>
          <Typography fontWeight={700} sx={{ color: "#1a2238", mb: 1.5 }}>Arkadaş Ekle</Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField fullWidth size="small" placeholder="Arkadaşının davet kodu" value={code}
              onChange={(e) => setCode(e.target.value)} onKeyDown={(e) => e.key === "Enter" && sendRequest()} />
            <Button variant="contained" onClick={sendRequest} disabled={busy} startIcon={<PersonAddIcon />}>İstek Gönder</Button>
          </Box>
        </CardContent>
      </Card>

      {/* Gelen istekler */}
      {requests.length > 0 && (
        <Card sx={{ borderRadius: 4, mb: 2.5, border: "1px solid rgba(245,158,11,0.3)", background: "rgba(245,158,11,0.06)" }}>
          <CardContent>
            <Typography fontWeight={700} sx={{ color: "#1a2238", mb: 1.5 }}>📨 Gelen İstekler ({requests.length})</Typography>
            {requests.map(r => (
              <Box key={r.id} sx={{ display: "flex", alignItems: "center", gap: 1.2, py: 0.8 }}>
                <Avatar sx={{ width: 32, height: 32, fontSize: 14, bgcolor: "rgba(79,124,255,0.15)", color: "#4F7CFF" }}>{(r.name || "Ö")[0].toUpperCase()}</Avatar>
                <Typography sx={{ flex: 1, fontWeight: 600, color: "#1a2238" }}>{r.name}</Typography>
                <Button size="small" variant="contained" disabled={busy} onClick={() => accept(r.id)}>Kabul Et</Button>
              </Box>
            ))}
          </CardContent>
        </Card>
      )}

      {/* Arkadaş listesi */}
      <Card sx={{ borderRadius: 4, border: "1px solid rgba(120,140,200,0.16)" }}>
        <CardContent>
          <Typography fontWeight={700} sx={{ color: "#1a2238", mb: 1.5 }}>Arkadaş Listen ({friends.length})</Typography>
          {friends.length === 0 && <Typography variant="body2" color="text.secondary">Henüz arkadaşın yok — yukarıdan davet koduyla ekle.</Typography>}
          {friends.map((f, i) => (
            <Box key={f.id}>
              {i > 0 && <Divider />}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, py: 1 }}>
                <Avatar sx={{ width: 36, height: 36, fontSize: 15, fontWeight: 700, bgcolor: "rgba(139,108,255,0.15)", color: "#8B6CFF" }}>{(f.name || "Ö")[0].toUpperCase()}</Avatar>
                <Typography sx={{ flex: 1, fontWeight: 600, color: "#1a2238" }} noWrap>{f.name}</Typography>
                <Chip size="small" icon={<LocalFireDepartmentIcon sx={{ fontSize: 16 }} />} label={`${f.streak || 0} gün`}
                  sx={{ fontWeight: 700, bgcolor: "rgba(245,158,11,0.12)", color: "#b45309" }} />
                <Chip size="small" label={`${f.weeklyXp || 0} XP`} sx={{ fontWeight: 700, bgcolor: "rgba(139,108,255,0.12)", color: "#8B6CFF" }} />
              </Box>
            </Box>
          ))}
        </CardContent>
      </Card>

      <Snackbar open={!!toast} autoHideDuration={2200} onClose={() => setToast("")} message={toast}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }} />
    </Box>
  );
}

